import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 82958DF7-5F5F-4470-BFB4-4389937B4D29
 * name arrow-up-box
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-box.svg
 * tags
 * - Arrow 
 */
export const ArrowUpBoxIcon = createSvgIcon(<><path d="M21,19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19C20.11,3 21,3.9 21,5V19M13,18V9.5L16.5,13L17.92,11.58L12,5.66L6.08,11.58L7.5,13L11,9.5V18H13Z" /></>, 'ArrowUpBoxIcon');
export default ArrowUpBoxIcon